import { render, staticRenderFns } from "./CampoDetalleUsuario.vue?vue&type=template&id=190dd842&"
import script from "./CampoDetalleUsuario.vue?vue&type=script&lang=js&"
export * from "./CampoDetalleUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports